// extracted by mini-css-extract-plugin
export default {"host":"styles_host__rO3RP","sidebar":"styles_sidebar__8obFx","main":"styles_main__j2LXv","overlayed":"styles_overlayed__ahGCb"};